// Nội dung tĩnh (mock) lấy từ nội dung thật của annhome.com.vn

export const site = {
  name: "Ann Home",
  tagline: "Căn bếp của những điều tử tế",
  title: "Ann Home - Eat Clean, Bánh Trung Thu, Bánh Kem & Lớp Dạy Làm Bánh",
  description:
    "Ann Home - căn bếp handmade tại TP.HCM: bữa ăn eat clean chuẩn dinh dưỡng, bánh Trung thu Mộc Hương Thu Nguyệt, bánh kem Min's Bake Studio làm tươi mỗi ngày và lớp dạy làm bánh lớp nhỏ.",
  logo: `/images/2023_05_annhome.webp`,
  ogImage: `/og-image.jpg`,
  facebook: "https://www.facebook.com/ann.home.eatclean",
  messenger: "https://m.me/ann.home.eatclean",
  zalo: "https://zalo.me/0976036467",
  phone: "0976 036 467",
  phoneHref: "tel:0976036467",
  email: "annhome.eatclean@gmail.com",
  address: "TP. Hồ Chí Minh",
  hours: "Thứ 2 - Chủ nhật: 07:00 - 20:00",
};

export const decor = {
  delimDark: `/images/2017_01_delim_small.webp`,
  delimWhite: `/images/2017_01_delim_white.webp`,
  delimSmallWhite: `/images/2017_01_small_white_delim.webp`,
};

export const heroSlides = [
  {
    id: 1,
    kicker: "Eat clean & Healthy food",
    title: "Eat Green. Be Healthy.",
    sub: "Bữa ăn eat clean chuẩn dinh dưỡng, giao tận nơi mỗi ngày",
    image: `/images/2017_01_small.webp`,
    to: "/eat-clean",
    ctaLabel: "Xem thực đơn",
  },
  {
    id: 2,
    kicker: "Mid-Autumn Collection 2026",
    title: "Mộc Hương Thu Nguyệt",
    sub: "Bánh Trung thu truyền thống, sắc màu & hoa ngàn lớp",
    image: `/images/tt/page-01.webp`,
    to: "/banh-trung-thu",
    ctaLabel: "Xem bộ sưu tập",
  },
  {
    id: 3,
    kicker: "Min's Bake Studio",
    title: "Bánh kem làm tươi mỗi ngày",
    sub: "Ít ngọt 30% · nguyên liệu Anchor, Président, Valrhona",
    image: `/images/2017_01_cooking.webp`,
    to: "/banh-kem",
    ctaLabel: "Xem mẫu bánh",
  },
];

export const introBlocks = [
  {
    id: "quality",
    kicker: "Eat clean & Healthy food",
    title: "Ann Home mang đến những điều chất lượng cho bạn",
    text: "Không chỉ là nơi ăn uống, Ann Home còn là một nơi cung cấp kiến thức về dinh dưỡng và chế độ ăn uống lành mạnh để khách hàng có thể tự tin lựa chọn các món ăn phù hợp với nhu cầu của mình và duy trì được thói quen ăn uống lành mạnh.",
    image: `/images/2017_01_cooking.webp`,
    reverse: false,
  },
  {
    id: "why-eatclean",
    kicker: "Eat clean & Healthy food",
    title: "Vì sao bạn chọn Eat Clean",
    text: "Eat Clean – Phương pháp ăn uống lành mạnh, giảm cân khoa học. Eat Clean và lối sống khoẻ mạnh giúp chúng ta sống vui vẻ hơn, hạnh phúc hơn và khoẻ đẹp hơn mỗi ngày. Eat Clean là phương pháp đẩy lùi, phòng chống và chữa bệnh.",
    image: `/images/2023_05_IMG_6557-1-500x666.webp`,
    reverse: true,
  },
  {
    id: "why-annhome",
    kicker: "Eat clean & Healthy food",
    title: "Vì sao bạn nên chọn các gói ăn tại Ann Home",
    text: "Thực đơn được thiết kế bởi các chuyên gia trong lĩnh vực dinh dưỡng, thực phẩm sạch và tươi được chọn lọc kỹ càng, chế biến theo tiêu chuẩn an toàn thực phẩm, không sử dụng chất bảo quản. Qui trình chuẩn bị và chế biến đảm bảo giữ nguyên hương vị và giá trị dinh dưỡng của nguyên liệu với bộ gia vị dành riêng cho phần ăn Healthy. Ann Home chia sẻ lợi ích của nguyên liệu và tính toán lượng Calories cần thiết hoặc theo nhu cầu khách hàng, đảm bảo món ăn đầy đủ dinh dưỡng và các chất cần thiết cho cơ thể.",
    image: `/images/2023_04_IMG_0473-scaled.webp`,
    reverse: false,
  },
];

export const bestSellers = [
  {
    id: "bs1",
    name: "Salad Cá hồi Teriyaki xốt cocktail",
    calo: "284CAL/KP",
    image: `/images/2023_04_IMG_0769-scaled.webp`,
  },
  {
    id: "bs2",
    name: "Bò xốt tiêu xanh + Cơm lứt đen",
    calo: "430CAL/KP",
    image: `/images/2023_04_IMG_0473-scaled.webp`,
  },
  {
    id: "bs3",
    name: "Tôm xốt xí muội Thái + Bún lứt đỏ",
    calo: "255CAL/KP",
    image: `/images/2023_04_IMG_4660-scaled.webp`,
  },
];

export const menuTabs = [
  {
    id: "eatclean",
    label: "Eat clean",
    items: [
      { name: "Tôm xốt Thái", calo: "255 Cal/KP", price: "70.000đ", desc: "Tôm áp chảo cùng xốt thái chua cay ngọt, rau củ luộc & xốt ăn kèm", image: `/images/2023_05_tomsotthai-scaled.webp` },
      { name: "Ức gà Teriyaki", calo: "348 Cal/KP", price: "55.000đ", desc: "Ức gà áp chảo cùng xốt Teriyaki, rau củ luộc & xốt ăn kèm", image: `/images/2023_05_ucgatereyaki-scaled.webp` },
      { name: "Bò xốt Bulgogi", calo: "433 Cal/KP", price: "60.000đ", desc: "Bò miếng ướp xốt Bulgogi, nướng thơm, rau củ luộc & xốt ăn kèm", image: `/images/2023_05_boblugogibun-scaled.webp` },
      { name: "Bò lúc lắc", calo: "412 Cal/KP", price: "60.000đ", desc: "Bò xào cùng ớt chuông, hành tây & xốt, rau củ luộc & xốt ăn kèm", image: `/images/2023_05_boluclac-scaled.webp` },
      { name: "Cốt lết xốt ớt + Bún lứt", calo: "353 Cal/KP", price: "60.000đ", desc: "Cốt lết ướp xốt ớt, nướng thơm, rau củ luộc & xốt ăn kèm", image: `/images/2023_05_cotletsotot-scaled.webp` },
      { name: "Ức gà xốt Thái", calo: "303 Cal/KP", price: "55.000đ", desc: "Ức gà với ớt chuông, hành tây & xốt chua cay ngọt, rau củ luộc & xốt ăn kèm", image: `/images/2023_05_ucgasotthai-scaled.webp` },
      { name: "Đùi gà xốt mắm me + Bún lứt", calo: "301 Cal/KP", price: "60.000đ", desc: "Đùi gà áp chảo với xốt mắm me chua cay ngọt, rau củ luộc & xốt ăn kèm", image: `/images/2023_05_duigamammebun-scaled.webp` },
      { name: "Bò xốt tiêu đen", calo: "414 Cal/KP", price: "60.000đ", desc: "Bò ướp xốt tiêu đen, xào cùng nấm đùi gà, rau củ luộc & xốt ăn kèm", image: `/images/2023_05_bosottieuden-scaled.webp` },
    ],
  },
  {
    id: "salad",
    label: "Salad",
    items: [
      { name: "Salad bò xốt thảo mộc", calo: "368 Cal/KP", price: "60.000đ", desc: "Bò áp chảo, rau xà lách hữu cơ, cà chua bi & xốt thảo mộc", image: `/images/2023_05_saladbothaomoc-scaled.webp` },
      { name: "Salad cá hồi xốt Teriyaki", calo: "258 Cal/KP", price: "70.000đ", desc: "Cá hồi áp chảo, rau xà lách hữu cơ & xốt Teriyaki", image: `/images/2023_05_IMG_0779-scaled.webp` },
      { name: "Salad ức gà xốt BBQ", calo: "274 Cal/KP", price: "50.000đ", desc: "Ức gà nướng BBQ, rau xà lách hữu cơ, bắp Mỹ & xốt BBQ", image: `/images/2023_05_saladucga-scaled.webp` },
      { name: "Salad tôm thảo mộc", calo: "236 Cal/KP", price: "60.000đ", desc: "Tôm áp chảo, rau xà lách hữu cơ & xốt thảo mộc", image: `/images/2023_05_IMG_0642-scaled.webp` },
      { name: "Salad đùi gà xốt ớt", calo: "367 Cal/KP", price: "50.000đ", desc: "Đùi gà áp chảo, rau xà lách hữu cơ & xốt ớt chua ngọt", image: `/images/2023_05_saladucgabbq-scaled.webp` },
      { name: "Salad tôm xốt ớt", calo: "258 Cal/KP", price: "60.000đ", desc: "Tôm áp chảo, rau xà lách hữu cơ & xốt ớt chua ngọt", image: `/images/2023_05_saladtombbq-scaled.webp` },
    ],
  },
  {
    id: "drinks",
    label: "Drinks",
    items: [
      { name: "Nước ép ổi", calo: "", price: "35.000đ", desc: "Làm đẹp da, chống lão hóa da", image: `/images/2023_05_epoi.webp` },
      { name: "Nước ép thơm", calo: "", price: "35.000đ", desc: "Cung cấp nguồn vitamin, khoáng chất cho cơ thể, tăng cường miễn dịch", image: `/images/2023_05_epthom.webp` },
      { name: "Nước ép cam", calo: "", price: "35.000đ", desc: "Cải thiện hệ miễn dịch, cải thiện làn da và giảm cân", image: `/images/2023_05_epthom.webp` },
      { name: "Nước ép dưa hấu", calo: "", price: "35.000đ", desc: "Đẹp da và dưỡng tóc, trị rối loạn tiêu hoá và giảm cân", image: `/images/2023_05_duahaau.webp` },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Thảo Nguyễn",
    avatar: `/images/2023_05_thao-135x135.webp`,
    stars: 4,
    text: "Mình đã thưởng thức Bò nướng sate và Salad Ann Home. Hương vị không hề ngán nha. Ổn, dịch vụ tốt và tỉ mỉ đến từng chi tiết. Một bữa trưa hoàn hảo và đảm bảo chất lượng.",
  },
  {
    id: 2,
    name: "Vũ Mai",
    avatar: `/images/2023_05_mai-135x135.webp`,
    stars: 5,
    text: "Ann Home đã chứng minh rằng ăn eat clean không hề tẻ nhạt. Tuyệt đối không. Gói ăn ổn nhất trong những tiệm tôi đã từng đến ở TP.HCM.",
  },
  {
    id: 3,
    name: "Stellar Nguyễn",
    avatar: `/images/2023_05_min-135x135.webp`,
    stars: 5,
    text: "Salad cá hồi xốt miso, gà áp chảo sate ớt là những món nhất định phải dùng! Tổng thể là hài lòng zì đâu á, mình giới thiệu cho mí bạn công ty vs thường đặt chung cho nhóm. Giá hợp lý, ăn ngon thiệt.",
  },
  {
    id: 4,
    name: "Hoài Thư",
    avatar: `/images/2023_05_thu-135x135.webp`,
    stars: 5,
    text: "Mình thấy bạn bè quảng cáo chổ này mấy lần, tranh thủ khuyến mãi đặt ăn thử, xứng đáng ăn thêm nhiều lần nữa.",
  },
  {
    id: 5,
    name: "Đức Long",
    avatar: "",
    stars: 5,
    text: "Lần đầu đặt hàng hài lòng zì đâu á, nước sốt đỉnh của chóp, khẩu phần vừa phải, mình đặt gói ăn hàng tuần nhưng không hề ngán nha, 10 đỉm.",
  },
  {
    id: 6,
    name: "Vũ Nam",
    avatar: `/images/2023_05_nam-135x135.webp`,
    stars: 4,
    text: "Thức ăn tươi, ngon, khá healthy, phù hợp với đứa lười nấu ăn như mình. Ngày nào cũng đều đều 3 bữa tiệm giao. Hâm nóng phát ăn ngay. Ăn riết quen ghiền eat clean lun á trời.",
  },
];

export const gallery = [
  { src: `/images/2023_04_IMG_0769-scaled.webp`, alt: "Salad c\u00e1 h\u1ed3i Teriyaki x\u1ed1t cocktail c\u1ee7a Ann Home" },
  { src: `/images/2023_04_IMG_0473-scaled.webp`, alt: "B\u00f2 x\u1ed1t ti\u00eau xanh \u0103n c\u00f9ng c\u01a1m l\u1ee9t \u0111en" },
  { src: `/images/2023_04_IMG_4660-scaled.webp`, alt: "T\u00f4m x\u1ed1t x\u00ed mu\u1ed9i Th\u00e1i \u0103n c\u00f9ng b\u00fan l\u1ee9t \u0111\u1ecf" },
  { src: `/images/2023_05_IMG_0642-scaled.webp`, alt: "Salad t\u00f4m th\u1ea3o m\u1ed9c t\u01b0\u01a1i m\u00e1t c\u1ee7a Ann Home" },
];

export const weeklyMenuImages = [
  { src: `/images/2023_05_1-1.webp`, alt: "Thực đơn tuần Ann Home - trang 1" },
  { src: `/images/2023_05_2-1.webp`, alt: "Thực đơn tuần Ann Home - trang 2" },
];

export const packages = [
  {
    id: "p1",
    name: "Gói 1 tuần",
    meals: "7 phần ăn",
    price: "420.000đ",
    note: "Phù hợp cho người mới bắt đầu làm quen eat clean",
    features: ["Thực đơn thay đổi mỗi ngày", "Tính toán calories theo nhu cầu", "Giao tận nơi trong TP.HCM"],
    highlight: false,
  },
  {
    id: "p2",
    name: "Gói 2 tuần",
    meals: "14 phần ăn",
    price: "800.000đ",
    note: "Lựa chọn được yêu thích nhất",
    features: ["Thực đơn thiết kế riêng", "Tư vấn dinh dưỡng 1-1", "Tặng 2 ly nước ép detox", "Giao tận nơi trong TP.HCM"],
    highlight: true,
  },
  {
    id: "p3",
    name: "Gói 1 tháng",
    meals: "30 phần ăn",
    price: "1.650.000đ",
    note: "Dành cho người theo lộ trình giảm cân dài hạn",
    features: ["Thực đơn theo lộ trình TDEE", "Theo dõi & điều chỉnh hàng tuần", "Tặng 5 ly nước ép detox", "Ưu tiên giao giờ cao điểm"],
    highlight: false,
  },
];

export const posts = [
  {
    slug: "cach-bao-quan-banh-trung-thu-giu-vo-mem-nhan-thom",
    title: "Cách bảo quản bánh Trung thu để giữ vỏ mềm và nhân thơm",
    excerpt:
      "Bánh Trung thu không chất bảo quản có hạn sử dụng ngắn hơn bánh công nghiệp. Vài lưu ý nhỏ dưới đây giúp bạn giữ được hương vị bánh trọn vẹn nhất.",
    image: `/images/tt/page-04.webp`,
    date: "2026-07-20",
    category: "Bánh Trung Thu",
    body: [
      "Bánh nướng của Ann Home có hạn sử dụng 12 ngày kể từ ngày sản xuất. Sau khi nướng, bánh cần 1-2 ngày để vỏ \"xuống dầu\" — lúc này vỏ mềm, bóng và thơm nhất, đó cũng là thời điểm ngon nhất để dùng.",
      "Hãy để bánh ở nơi khô mát, tránh ánh nắng trực tiếp và tránh nơi có mùi mạnh. Không cần cho vào tủ lạnh khi bánh còn trong hạn, vì nhiệt độ thấp làm vỏ bánh bị khô và cứng lại.",
      "Với dòng bánh hoa ngàn lớp (Vọng Nguyệt, Thưởng Nguyệt), vỏ bánh mỏng nhiều lớp nên bạn dùng trong 3-5 ngày để cảm nhận đúng độ giòn tan. Nếu bảo quản lạnh, hãy để bánh ra ngoài 20-30 phút trước khi dùng.",
      "Bánh đã cắt nên dùng hết trong ngày. Khi dùng, cắt bánh thành 6-8 miếng nhỏ và uống kèm trà olong hoặc trà sen sẽ giúp giảm cảm giác ngọt và dễ tiêu hơn.",
    ],
  },
  {
    slug: "chon-banh-kem-sinh-nhat-it-ngot-cho-be",
    title: "Chọn bánh kem sinh nhật ít ngọt cho bé: cần lưu ý gì?",
    excerpt:
      "Bé nhỏ vẫn có thể thưởng thức bánh sinh nhật nếu bạn chọn đúng loại kem, đúng độ ngọt và đúng nguyên liệu. Đây là những tiêu chí Ann Home luôn áp dụng.",
    image:
      "/images/ext/cake-chocolate-mousse.webp",
    date: "2026-07-18",
    category: "Bánh Kem",
    body: [
      "Điều quan trọng nhất là loại kem. Hãy ưu tiên kem tươi động vật (whipping cream) thay vì kem thực vật (topping) — kem tươi tan nhẹ trong miệng, ít ngấy và không để lại vị béo nặng ở cổ.",
      "Thứ hai là độ ngọt. Công thức của Ann Home giảm khoảng 30% lượng đường so với công thức truyền thống, đủ để bánh vẫn nổi vị nhưng không làm bé bị \"say\" đường sau vài miếng.",
      "Thứ ba là màu sắc trang trí. Nên chọn màu từ nguyên liệu tự nhiên như matcha, chocolate, bột củ dền, trái cây tươi; hạn chế phẩm màu công nghiệp và các loại kẹo trang trí nhiều màu.",
      "Cuối cùng là độ tươi. Bánh làm theo đơn và giao trong ngày sẽ luôn an toàn hơn bánh trưng tủ nhiều giờ. Với bé dưới 2 tuổi, bạn nên cho bé dùng phần cốt bánh và một ít kem, tránh phần trang trí cứng.",
    ],
    minBakeLinks: [
      {
        href: "https://www.minnbake.com/",
        label: "bánh sinh nhật handmade Dĩ An",
      },
      {
        href: "https://www.minnbake.com/banh-kem-it-ngot-di-an",
        label: "bánh kem ít ngọt Dĩ An",
      },
    ],
  },
  {
    slug: "bmr-la-gi-cach-tinh-bmr-de-len-thuc-don-tang-giam-can",
    title: "BMR là gì? cách tính BMR để lên thực đơn tăng giảm cân?",
    excerpt:
      "Nhiều người không đạt được kết quả bởi vì chúng ta chỉ quan tâm đến tập luyện mà bỏ qua Dinh Dưỡng, thứ mà chiếm đến 60% yếu tố thành công.",
    image: `/images/2023_04_cong-cu-tinh-luong-calo-de-giam-can-2-768x512.webp`,
    date: "2023-04-18",
    category: "Kiến Thức",
    body: [
      "BMR (Basal Metabolic Rate) là tỷ lệ trao đổi chất cơ bản – lượng năng lượng tối thiểu mà cơ thể cần để duy trì các hoạt động sống khi bạn nghỉ ngơi hoàn toàn: hô hấp, tuần hoàn, duy trì thân nhiệt, hoạt động của các cơ quan nội tạng.",
      "Công thức Mifflin-St Jeor được sử dụng phổ biến nhất hiện nay. Với nam: BMR = 10 x cân nặng (kg) + 6.25 x chiều cao (cm) - 5 x tuổi + 5. Với nữ: BMR = 10 x cân nặng (kg) + 6.25 x chiều cao (cm) - 5 x tuổi - 161.",
      "Sau khi có BMR, bạn nhân với hệ số vận động để ra TDEE – tổng năng lượng tiêu thụ mỗi ngày. Muốn giảm cân, hãy ăn thấp hơn TDEE khoảng 10-20%; muốn tăng cân thì ăn cao hơn TDEE 10-15%. Tuyệt đối không nên ăn dưới mức BMR trong thời gian dài vì sẽ làm chậm chuyển hoá.",
      "Tại Ann Home, mỗi phần ăn đều được ghi rõ lượng calories để bạn dễ dàng kiểm soát khẩu phần theo đúng mục tiêu của mình.",
    ],
  },
  {
    slug: "tdee-la-gi-cach-thiet-ke-thuc-don-an-uong-cho-tung-ca-nhan",
    title: "TDEE là gì? cách thiết kế thực đơn ăn uống cho từng cá nhân",
    excerpt:
      "Để đạt được hiệu quả trong tập luyện như tăng hay giảm cân thì thực đơn ăn uống là yếu tố rất quan trọng và TDEE là chỉ số tiên quyết cho việc đó.",
    image: `/images/2023_04_tinh-tdee-768x512.webp`,
    date: "2023-04-16",
    category: "Kiến Thức",
    body: [
      "TDEE (Total Daily Energy Expenditure) là tổng lượng calo cơ thể bạn tiêu thụ trong một ngày, bao gồm BMR cộng với năng lượng cho vận động, tiêu hoá thức ăn và các hoạt động thường ngày.",
      "TDEE = BMR x hệ số vận động. Hệ số 1.2 nếu ít vận động, 1.375 vận động nhẹ (1-3 ngày/tuần), 1.55 vận động vừa (3-5 ngày/tuần), 1.725 vận động nhiều (6-7 ngày/tuần), 1.9 vận động rất nhiều.",
      "Khi đã biết TDEE, hãy chia macro hợp lý: 30-40% protein, 30-40% carb và 20-30% chất béo tốt. Ưu tiên tinh bột chậm như gạo lứt, yến mạch, khoai lang và protein nạc như ức gà, cá hồi, tôm, bò nạc.",
      "Thực đơn gói tuần/tháng của Ann Home được thiết kế dựa trên chỉ số TDEE của từng khách hàng, giúp bạn không phải tự cân đo mỗi ngày.",
    ],
  },
  {
    slug: "bang-thanh-phan-dinh-duong-cua-hon-600-thuc-pham-mon-an-tai-viet-nam",
    title: "Bảng thành phần dinh dưỡng của hơn 600 thực phẩm, món ăn tại Việt Nam",
    excerpt: "Bảng thành phần dinh dưỡng của hơn 600 thực phẩm, món ăn tại Việt Nam.",
    image: `/images/2023_04_bang-thanh-phan-dinh-duong-768x512.webp`,
    date: "2023-04-14",
    category: "Kiến Thức",
    body: [
      "Việc nắm được thành phần dinh dưỡng của thực phẩm quen thuộc giúp bạn chủ động hơn khi lên thực đơn hằng ngày, thay vì phải đoán lượng calo của từng món.",
      "Bảng thành phần dinh dưỡng thống kê hơn 600 thực phẩm và món ăn phổ biến tại Việt Nam kèm theo lượng năng lượng, đạm, béo, đường bột, chất xơ và các vi chất trên 100g phần ăn được.",
      "Một vài con số đáng nhớ: 100g cơm trắng ~130 Kcal, 100g cơm gạo lứt ~110 Kcal, 100g ức gà luộc ~165 Kcal, 100g cá hồi ~208 Kcal, 100g tôm ~99 Kcal, 100g khoai lang ~86 Kcal.",
      "Hãy dùng bảng này như một cuốn từ điển tra nhanh, kết hợp với cân thực phẩm trong 2-3 tuần đầu để hình thành cảm giác về khẩu phần.",
    ],
  },
  {
    slug: "calo-la-gi-nguoi-muon-giam-can-bat-buoc-phai-hieu-ve-no",
    title: "Calo là gì? Người muốn giảm cân bắt buộc phải hiểu về nó",
    excerpt:
      "Cơ thể cần năng lượng cho mọi hoạt động sống, năng lượng đó được đo bằng Calo (Cal), là yếu tố quan trọng cho mọi hoạt động sống từ tế bào đến cơ thể.",
    image: `/images/2023_04_calo-la-gi-calories-la-gi-768x512.webp`,
    date: "2023-04-12",
    category: "Kiến Thức",
    body: [
      "Calo (calorie) là đơn vị đo năng lượng. Trong dinh dưỡng, chúng ta thường dùng Kcal – tức 1000 calo. Mọi hoạt động sống từ cấp độ tế bào tới vận động cơ bắp đều cần năng lượng này.",
      "1g đạm cung cấp 4 Kcal, 1g đường bột cung cấp 4 Kcal, 1g chất béo cung cấp 9 Kcal và 1g cồn cung cấp 7 Kcal. Đây là lý do các món nhiều dầu mỡ rất dễ khiến bạn vượt ngưỡng calo.",
      "Nguyên tắc giảm cân cốt lõi vẫn là thâm hụt năng lượng: ăn vào ít hơn tiêu hao. Tuy nhiên chất lượng calo cũng quan trọng – 500 Kcal từ ức gà, gạo lứt và rau xanh sẽ khác hoàn toàn 500 Kcal từ trà sữa.",
      "Mỗi phần ăn tại Ann Home đều ghi rõ số Kcal trên khẩu phần (CAL/KP) để bạn kiểm soát dễ dàng mà không cần tính toán.",
    ],
  },
  {
    slug: "top-7-thuc-don-eat-clean-giam-can-cap-toc-trong-2-tuan",
    title: "TOP 7 thực đơn Eat Clean giảm cân cấp tốc trong 2 tuần",
    excerpt: "Giới thiệu cho các bạn 7 thực đơn Eat Clean giảm cân siêu tốc trong vòng 2 tuần để các bạn tham khảo.",
    image: `/images/2023_04_thucdongiamcan-768x512.webp`,
    date: "2023-04-10",
    category: "Kiến Thức",
    body: [
      "Nguyên tắc chung của 7 thực đơn dưới đây là giữ mức 1200-1500 Kcal mỗi ngày, ưu tiên đạm nạc, tinh bột chậm và thật nhiều rau xanh.",
      "Ngày 1: Yến mạch sữa hạt + chuối / Ức gà áp chảo + cơm gạo lứt + bông cải / Salad tôm thảo mộc. Ngày 2: Trứng luộc + bánh mì nguyên cám / Cá hồi áp chảo + khoai lang / Súp bí đỏ.",
      "Ngày 3: Sinh tố bơ chuối / Bò xốt tiêu đen + cơm lứt đen / Salad ức gà BBQ. Ngày 4: Yến mạch trái cây / Đùi gà xốt mắm me + bún lứt / Ức gà xốt Thái.",
      "Ngày 5-7 luân phiên các món trên và tăng dần rau xanh. Uống 2-2.5 lít nước mỗi ngày, ngủ đủ 7-8 tiếng và đi bộ 30 phút để tối ưu hiệu quả.",
    ],
  },
  {
    slug: "mach-ban-cach-nau-com-gao-lut-sieu-mem-deo",
    title: "Mách bạn cách nấu cơm gạo lứt siêu mềm dẻo",
    excerpt:
      "Với bảng thành phần đặc sắc bao gồm chất xơ, các loại vitamin và nhiều khoáng chất, gạo lứt được xếp vào dàn “siêu thực phẩm” bởi các chuyên gia dinh dưỡng.",
    image: `/images/2023_04_naugaolutbangbepga-768x512.webp`,
    date: "2023-04-08",
    category: "Kiến Thức",
    body: [
      "Gạo lứt giữ nguyên lớp cám nên giàu chất xơ, vitamin nhóm B và khoáng chất, nhưng cũng vì vậy mà hạt gạo cứng và lâu chín hơn gạo trắng.",
      "Bí quyết đầu tiên là ngâm gạo. Ngâm gạo lứt trong nước ấm 4-8 tiếng (hoặc qua đêm) giúp hạt gạo nở, mềm và giảm bớt axit phytic khó tiêu.",
      "Tỉ lệ nước lý tưởng là 1 gạo : 1.5-2 nước tuỳ loại lứt đỏ hay lứt đen. Thêm một chút muối và vài giọt dầu ô liu sẽ giúp cơm bóng, thơm và tơi hơn.",
      "Sau khi nồi báo chín, hãy ủ thêm 15-20 phút rồi mới xới. Đây là bước quan trọng nhất giúp cơm gạo lứt mềm dẻo như cơm trắng.",
    ],
  },
  {
    slug: "thuc-don-eat-clean-la-gi-an-eat-clean-khac-gi-so-voi-an-healthy",
    title: "Thực đơn eat clean là gì? Ăn eat clean khác gì so với ăn healthy?",
    excerpt:
      "Thực đơn eat clean và keto healthy đều có đặc điểm chung là phục vụ cho mục đích giảm cân. Tuy nhiên chế độ ăn eat clean mang nhiều ưu điểm hơn.",
    image: `/images/2023_04_ketohealthy-1-768x512.webp`,
    date: "2023-04-06",
    category: "Kiến Thức",
    body: [
      "Eat clean nghĩa là “ăn sạch” – ưu tiên thực phẩm nguyên bản, ít qua chế biến, không phụ gia, không chất bảo quản và hạn chế tối đa đường tinh luyện.",
      "Ăn healthy là khái niệm rộng hơn, chỉ chế độ ăn cân bằng và tốt cho sức khoẻ. Một món healthy vẫn có thể qua chế biến nhiều bước, còn eat clean thì đề cao sự nguyên bản của nguyên liệu.",
      "Về phương pháp chế biến, eat clean ưu tiên luộc, hấp, áp chảo ít dầu, nướng; hạn chế chiên ngập dầu. Gia vị dùng ở mức tối thiểu và thường là gia vị tự nhiên.",
      "Nếu bạn muốn giảm cân bền vững mà vẫn ăn ngon, eat clean là lựa chọn dễ duy trì lâu dài nhất.",
    ],
  },
  {
    slug: "so-sanh-che-do-an-tho-an-healthy-an-eat-clean-va-an-diet",
    title: "So sánh chế độ ăn thô, ăn healthy, ăn eat clean và ăn diet",
    excerpt:
      "Nhu cầu về sức khỏe ngày càng tăng cao trong cuộc sống hiện đại dẫn theo ngày càng nhiều phương pháp ăn uống ra đời.",
    image: `/images/2023_04_healthylagi-1-768x512.webp`,
    date: "2023-04-04",
    category: "Kiến Thức",
    body: [
      "Ăn thô (raw food) là chế độ ăn thực phẩm chưa qua nấu nướng hoặc chỉ chế biến dưới 47 độ C, giữ tối đa enzyme và vi chất nhưng khá khó duy trì.",
      "Ăn healthy hướng tới sự cân bằng dinh dưỡng, không loại bỏ nhóm chất nào, phù hợp với hầu hết mọi người.",
      "Eat clean nhấn mạnh vào độ “sạch” và nguyên bản của nguyên liệu, kiểm soát khẩu phần và calories – rất phù hợp cho mục tiêu giảm cân, giữ dáng.",
      "Ăn diet thường là chế độ cắt giảm mạnh một nhóm chất (ví dụ low-carb, keto) trong thời gian ngắn để đạt mục tiêu nhanh, cần theo dõi sát để tránh ảnh hưởng sức khoẻ.",
    ],
  },
];

export const faqs = [
  {
    q: "Ann Home giao hàng ở những khu vực nào?",
    a: "Ann Home giao hàng tại tất cả các quận nội thành TP. Hồ Chí Minh. Với các khu vực xa trung tâm, bạn vui lòng nhắn tin Fanpage để được báo phí giao hàng cụ thể.",
  },
  {
    q: "Đặt món trước bao lâu thì được giao?",
    a: "Đơn lẻ trong ngày vui lòng đặt trước 10:00 cho bữa trưa và trước 15:00 cho bữa chiều. Gói tuần/tháng nên đặt trước 1 ngày để bếp chuẩn bị nguyên liệu tươi.",
  },
  {
    q: "Món ăn bảo quản được bao lâu?",
    a: "Phần ăn không dùng chất bảo quản nên tốt nhất dùng trong ngày. Nếu chưa dùng ngay, bạn bảo quản ngăn mát 0-4 độ C tối đa 24 giờ và hâm nóng lại trước khi ăn.",
  },
  {
    q: "Tôi có thể yêu cầu thực đơn riêng theo mức calories không?",
    a: "Hoàn toàn được. Ann Home sẽ dựa trên chỉ số BMR/TDEE, cân nặng, chiều cao và mục tiêu của bạn để thiết kế thực đơn với mức calories phù hợp.",
  },
  {
    q: "Ăn eat clean bao lâu thì thấy hiệu quả giảm cân?",
    a: "Trung bình sau 2-4 tuần duy trì đều đặn kết hợp vận động nhẹ, bạn sẽ thấy thay đổi rõ về cân nặng và vóc dáng. Tốc độ an toàn là 0.5-1kg mỗi tuần.",
  },
  {
    q: "Thực đơn có thay đổi mỗi ngày không?",
    a: "Có. Thực đơn được xoay vòng theo tuần với hơn 30 món khác nhau, đảm bảo bạn không bị ngán và vẫn đủ dinh dưỡng.",
  },
  {
    q: "Tôi bị dị ứng một số nguyên liệu, có đổi món được không?",
    a: "Bạn vui lòng thông báo trước danh sách nguyên liệu cần tránh, bếp sẽ thay thế bằng nguyên liệu tương đương về dinh dưỡng.",
  },
  {
    q: "Bánh Trung thu Ann Home để được bao lâu?",
    a: "Bánh nướng có hạn sử dụng 12 ngày kể từ ngày sản xuất, bảo quản nơi khô mát, tránh ánh nắng. Bánh hoa ngàn lớp nên dùng trong 3-5 ngày để giữ độ mềm của lớp vỏ.",
  },
  {
    q: "Đặt bánh Trung thu số lượng lớn làm quà doanh nghiệp được không?",
    a: "Được. Ann Home nhận đơn quà tặng doanh nghiệp, có thể in thiệp và tem theo thương hiệu của bạn. Đơn số lượng lớn vui lòng đặt trước 7-10 ngày.",
  },
  {
    q: "Bánh hoa ngàn lớp giao ngày nào?",
    a: "Dòng bánh hoa ngàn lớp (Vọng Nguyệt, Thưởng Nguyệt) chốt order và trả đơn vào thứ 3 và thứ 6 hàng tuần.",
  },
  {
    q: "Bánh kem cần đặt trước bao lâu?",
    a: "Bánh kem làm tươi theo đơn, bạn chỉ cần đặt trước 4 giờ là nhận được bánh trong ngày. Mẫu decor phức tạp nên đặt trước 1 ngày.",
  },
  {
    q: "Bánh kem có ít ngọt không, bé nhỏ ăn được chứ?",
    a: "Toàn bộ bánh kem giảm 30% đường so với công thức truyền thống, dùng cream Anchor và không chất bảo quản nên phù hợp với bé từ 1 tuổi.",
  },
  {
    q: "Lớp học làm bánh có cần kinh nghiệm trước không?",
    a: "Không cần. Các lớp cơ bản được thiết kế cho người mới hoàn toàn. Lớp Mousse & Entremet nâng cao nên đã từng làm bánh hoặc học qua lớp cơ bản.",
  },
  {
    q: "Học phí lớp làm bánh đã bao gồm nguyên liệu chưa?",
    a: "Đã bao gồm toàn bộ nguyên liệu, dụng cụ, tài liệu công thức in và bạn mang hết bánh thành phẩm về nhà.",
  },
  {
    q: "Thanh toán bằng hình thức nào?",
    a: "Ann Home nhận thanh toán tiền mặt khi nhận hàng, chuyển khoản ngân hàng và ví điện tử Momo/ZaloPay.",
  },
];

export const navMain = [
  { label: "Trang chủ", to: "/" },
  {
    label: "Sản phẩm",
    children: [
      { label: "Bữa ăn Eat Clean", to: "/eat-clean", desc: "Thực đơn chuẩn dinh dưỡng, ghi rõ calories" },
      { label: "Bánh Trung Thu", to: "/banh-trung-thu", desc: "Bộ sưu tập Mộc Hương Thu Nguyệt 2026" },
      { label: "Bánh Kem", to: "/banh-kem", desc: "Min's Bake Studio - làm tươi mỗi ngày" },
      { label: "Lớp Dạy Làm Bánh", to: "/lop-hoc-lam-banh", desc: "Lớp nhỏ 4-6 người cùng bếp trưởng" },
    ],
  },
  { label: "Kiến Thức", to: "/danh-muc/kien-thuc" },
  { label: "Hỏi đáp", to: "/hoi-dap" },
  { label: "Liên hệ", to: "/lien-he" },
];

export const navFlat = [
  { label: "Trang chủ", to: "/" },
  { label: "Bữa ăn Eat Clean", to: "/eat-clean" },
  { label: "Bánh Trung Thu", to: "/banh-trung-thu" },
  { label: "Bánh Kem", to: "/banh-kem" },
  { label: "Lớp Dạy Làm Bánh", to: "/lop-hoc-lam-banh" },
  { label: "Kiến Thức", to: "/danh-muc/kien-thuc" },
  { label: "Hỏi đáp", to: "/hoi-dap" },
  { label: "Liên hệ", to: "/lien-he" },
];
